module.exports = __webpack_public_path__ + "img/serviceLines.ca67b730.svg";